export class LaboratoryRequestIndicatorListItem {
    laboratoryRequestIndicatorId: number;
    requestId: number;
    activityId: number;
    value: number;
    stringValue: string;
    performerUserId: number;
    performerUserName: string;
    laboratoryIndicatorId: number;
    laboratoryIndicatorName: string;
    laboratoryIndicatorUnit: string;
    laboratoryExaminationMethodId: number;
    laboratoryExaminationMethodName: string;
    shouldBeDoneDateTime: Date;
    wasDoneDateTime: Date;
    normalValueMax: number;
    normalValueMin: number;
    accuracy: number;
    inaccuracy: number;
    valueText: string;
    exceeding: number;
    inaccuracyText: string;
    comment: string;
}